// RailsのViewにマウントするためのエントリポイント
import React from 'react';
import { FacilityOrderChat } from './components';
import { FacilityFavoriteRecreationList } from './components/facilityFavoriteRecreation/components/favoriteRecreationList';
import { FacilityConsultPrice } from './components/facilityConsultPrice';
import { mountComponent } from './utils';

/**
 * FacilityOrderChat
 * mount path: /customers/orders/:id/chat
 */
mountComponent('#OrderChat', () => <FacilityOrderChat />);

/**
 * FavoriteRecreationIndex
 * mount path: / || /customers/recreations
 */
mountComponent(() => {
  const elements = Array.from(document.querySelectorAll('[id^=favoriteIcon_]'));
  if (elements.length === 0) return null;

  return <FacilityFavoriteRecreationList elements={elements} />;
});

/**
 * FacilityConsultPrice
 * mount path: /customers/recreations/${recreationId} || /customers/recreations/${recreationId}/evaluations
 */
mountComponent('#ConsultRecreation', () => {
  const recreationId = window.location.pathname.split('/')[3];
  if (!recreationId) return null;

  return <FacilityConsultPrice recreationId={Number(recreationId)} />;
});
